/**
 * Balatro-Style CRT Screen Effect
 * Global overlay with barrel warp, scanlines, and vignette
 */
import { useEffect } from 'react';

export const CRTScreen = () => {
  useEffect(() => {
    // Add CRT class to body for global styling hooks
    document.body.classList.add('crt-enabled');
    return () => document.body.classList.remove('crt-enabled');
  }, []);

  return (
    <div className="crt-screen-overlay" aria-hidden="true">
      {/* Scanline layer */}
      <div className="crt-scanlines" />
      {/* Barrel warp curvature via SVG filter */}
      <svg className="crt-warp-filter" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="crt-warp">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0.3" result="blur" />
            <feColorMatrix
              in="blur"
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      0 0 0 1 0"
            />
          </filter>
        </defs>
      </svg>
      {/* Vignette */}
      <div className="crt-vignette" />
      {/* Subtle screen curvature highlight */}
      <div className="crt-curvature" />
      {/* RGB separation for authentic CRT feel */}
      <div className="crt-rgb-separation" />
    </div>
  );
};

export default CRTScreen;
